import { gql } from '@apollo/client'

export const PAGING = gql`
  fragment Paging on Paging {
    skip
    limit
    hasNext
  }
`

export const PAGING_WITH_COUNT = gql`
  fragment Paging on Paging {
    totalCount
    skip
    limit
    hasNext
  }
`
